import styled from "styled-components"

import {
  desktopTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"


export const SectionTitle = styled.h2`
  grid-column: 1 / -1;
  ${mobileTextStyles.MobileHeadingTwoRegular}

  color: var(--white);

  & > span {
    font-weight: 500;
  }
  text-align: left;

  @media (min-width: ${Breakpoints.md}) {
    text-align: center;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoRegular}
    text-align: center;
    grid-column: 3 / -3;
    grid-row: 1;
  }
`
export const DescriptionText = styled.p`
  ${desktopTextStyles.BodyText18}
  color: var(--dark-mode-body-grey);
  margin-top: 32px;
  text-align: left;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    ${desktopTextStyles.BodyText16}
    grid-column: 2 / -2;
    text-align: center;
    margin-top: 24px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    text-align: center;
    grid-column: 3 / -3;
    grid-row: 2;
  }
`